import { Grid } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import AppSummarySearchBar from '@/common/components/form-inputs/AppSummarySearchBar';
import { StaffSimpleFilter } from '@/api/DTO/user-management/userManagementList.interface';
import { useGetAllEnumListQuery } from '@/api/common';
import { YESNOLIST } from '@/common/constants/common';
import AppMultipleDropDownMenu from '@/common/components/form-inputs/AppMultipleDropDownMenu';

export default function UserManagementSummaryPageFilterSection() {
	const { t } = useTranslation();
	const { control } = useFormContext<StaffSimpleFilter>();

	const { data: allEnumList } = useGetAllEnumListQuery(null, {
		refetchOnMountOrArgChange: true,
	});

	return (
		<Grid container rowSpacing={2} columnSpacing={1}>
			<Grid size={3}>
				<AppSummarySearchBar
					name='searchString'
					control={control}
					placeholder={t('common.search')}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='roles'
					label={t('user.role')}
					options={(allEnumList?.data.StaffRoleEnum || []).map((item: any) => {
						return {
							...item,
							id: item.code,
							name: item.desc,
						};
					})}
				/>
			</Grid>
			<Grid size={2}>
				<AppMultipleDropDownMenu
					control={control}
					name='existInAD'
					label={t('user.existInAD')}
					options={YESNOLIST}
				/>
			</Grid>
		</Grid>
	);
}
